
<b-container style="margin-top: 70px">
  <b-row>
    <b-col>
      <b-card no-body no-header>
        <b-card-header>
          <div class="text-center">
            <h5 class="font-weight-bold"> Quote Summary</h5>
          </div>
        </b-card-header>
        <b-table-lite small
                      borderless
                      striped
                      stacked="lg"
                      class="mb-0"
                      :items="sorted_rows"
                      :fields="fields">
          <template v-slot:cell(part_number)="data">
            {{ data.item.code }}
          </template>
          <template v-slot:cell(part_description)="data">
            {{ data.item.name }}<br>
            <b-button variant="success" size="sm"
                      :to="{name:'reconfigure_bto_path',params:{quote_version_id:quote_version_id,quote_part_id:quote_part_id,quote_product_id:data.item.product.id}}"
                      v-if="data.item.product_detail === undefined">
              Reconfigure
            </b-button>
          </template>
          <template v-slot:cell(quantity)="data" v-if="quantity_visible">
            <b-dropdown variant="primary" :text="quantityLabel(data.item.product)">
              <b-dropdown-item v-for="option in quantity_options" @click="handleQuantityChange(data.item.product, option.key)">{{option.label}}</b-dropdown-item>
            </b-dropdown>
          </template>
          <template v-slot:cell(msrp_price)="data">
            {{ formatCurrency(data.item.msrp_price) }}
          </template>
          <template v-slot:cell(partner_price)="data" v-if="your_price_visible">
            {{ formatCurrency(data.item.partner_price) }}
          </template>
          <template v-slot:cell(actions)="data">
            <b-button variant="danger" size="sm" @click="removeItem(data.item)">
              Remove
            </b-button>
          </template>
        </b-table-lite>
        <b-card-footer>
          <div class="text-center">
            <b-button variant="primary" size="lg" :to="{name:'quote_request_path'}" class="mr-5">Request A Quote</b-button>
            <!-- b-button variant="primary" size="lg" @click="handleQuoteLetter">View Quote Letter</b-button -->
          </div>
        </b-card-footer>
      </b-card>
    </b-col>
  </b-row>
</b-container>
